import { useCustomerSecuritiesBySymbol } from '@src/providers';
import {
  type ColumnDef,
  type InputsAndDropdownsDrawerOption,
  type Security,
  type SymbolGroup,
  useSecuritiesContext,
} from '@talos/kyoko';
import { filter } from 'lodash-es';
import { useMemo } from 'react';

export function getSymbolGroupsPostPath(entity: SymbolGroup): string {
  return entity.Symbol == null ? `/symbol-groups` : `/symbol-groups/${encodeURIComponent(entity.Tier)}/symbols`;
}

export function getSymbolGroupsPatchDeletePath(entity: SymbolGroup): string {
  return entity.Symbol == null
    ? `/symbol-groups/${encodeURIComponent(entity.Tier)}`
    : `/symbol-groups/${encodeURIComponent(entity.Tier)}/symbols/${entity.Symbol}`;
}

export const SYMBOL_GROUPS_COLUMNS: ColumnDef<SymbolGroup>[] = [{ field: 'Tier', type: 'text', sort: '+' }];
export const SYMBOL_GROUPS_SYMBOLS_COLUMNS: ColumnDef<SymbolGroup>[] = [
  { field: 'Symbol', type: 'security', sort: '+', flex: 1 },
];

export const SYMBOL_GROUPS_DRAWER_OPTIONS: InputsAndDropdownsDrawerOption<SymbolGroup>[] = [
  {
    field: 'Tier',
    type: 'input',
    getIsRequired: () => true,
    disabledWhenEditing: true,
    title: 'Name',
    validate: form => {
      if (form.Tier && !form.Tier.match(/^[a-zA-Z0-9.-]+$/)) {
        return 'Name must only contain alphanumeric characters, hyphens and periods';
      }
      return undefined;
    },
  },
];

export function useFilteredCustomerSecurities(): Security[] {
  const { securitiesBySymbol } = useSecuritiesContext();
  const customerSecuritiesBySymbol = useCustomerSecuritiesBySymbol();

  return useMemo((): Security[] => {
    if (!customerSecuritiesBySymbol) {
      return [];
    }

    // Return an array of securities that exist in customerSecuritiesBySymbol
    return filter(Array.from(securitiesBySymbol.values()), security => customerSecuritiesBySymbol.has(security.Symbol));
  }, [customerSecuritiesBySymbol, securitiesBySymbol]);
}
